import type { OccConfig } from '@vista-digital/occ-ui'
import { CaptchaType, FieldFormatType } from '@vista-digital/occ-ui'
import type { NestedPartial } from '@vista-digital/utilities'
import { cmsDataService } from '@/common/services/cms.data.service'

/**
 * Overrides the default OccConfig while respecting text from CMS config
 *
 * *Note!* This function currently only handles the `form.fieldValidation.password` configuration. Making it flexible
 * to support all config options would require significant development effort. The implementation can be expanded
 * to support additional configurations if needed in the future.
 * */
export const getCustomOccConfig = (): NestedPartial<OccConfig> => {
    const displayText = cmsDataService.initialData
    return {
        form: {
            fieldValidation: {
                password: {
                    type: FieldFormatType.Password,
                    required: true,
                    maxLength: 64,
                    rules: [
                        {
                            displayText: displayText.passwordRuleCheckerUppercaseRule,
                            regExpression: '([A-Z])',
                        },
                        {
                            displayText: displayText.passwordRuleCheckerLowercaseRule,
                            regExpression: '([a-z])',
                        },
                        {
                            displayText: displayText.passwordRuleCheckerNumericRule,
                            regExpression: '([0-9])',
                        },
                        {
                            displayText: displayText.passwordRuleCheckerSpecialCharacterRule,
                            regExpression:
                                '[\'\\/\\!\\@#\\$\\%\\^\\&\\*\\)\\(\\+\\=\\.\\<\\>\\{\\}\\[\\]\\:\\;\\|\\~\\`\\_\\-,\\?\\¬£"]',
                        },
                        {
                            displayText: displayText.passwordRuleCheckerMinLengthRule,
                            regExpression: '.{8,}',
                        },
                    ],
                },
            },
        },
        security: {
            captcha: {
                type: CaptchaType.CloudflareTurnstile,
                siteKey: cmsDataService.get().captcha.siteKey,
            },
        },
    }
}
